<div class="payment-center-container">
  <!-- Back button -->
  <button mat-icon-button (click)="gotoDashboard()" aria-label="Go back to dashboard" class="back-button">
    <mat-icon>arrow_back</mat-icon>
  </button>

  <!-- Header section with title and description -->
  <div class="payment-header">
    <h1>Make Payment</h1>
    <p class="payment-subtitle">Review your balance and make a secure payment</p>
  </div>

  <!-- Payment summary and form container -->
  <div class="payment-container">
    <!-- Left side: Payment Summary -->
    <div class="payment-summary">
      <mat-card class="summary-card">
        <mat-card-title>Your Balance Summary</mat-card-title>
        <mat-card-content>
          <!-- Account balance component -->
          <app-account-balance></app-account-balance>

          <!-- Last visits summary -->
          <div class="recent-visits" *ngIf="recentVisits.length > 0">
            <h3>Recent Visits</h3>
            <div class="visit-list">
              <div *ngFor="let visit of recentVisits" class="visit-item">
                <div class="visit-date">{{ visit.date | date:'MMM d, yyyy' }}</div>
                <div class="visit-service">{{ visit.service }}</div>
                <div class="visit-amount">{{ visit.amount | currency }}</div>
              </div>
            </div>
            <div class="visit-actions">
              <a routerLink="/dashboard/account-history" class="view-all-link">
                Complete Blanace History
              </a>
              <button mat-stroked-button class="download-button" (click)="generatePdf()">
                <mat-icon>download</mat-icon> Download
              </button>   
            </div>         
          </div>
          <div>
            <p class="no-visits" *ngIf="recentVisits.length === 0">
              No recent visits available.
            </p>
          </div>
        </mat-card-content>
      </mat-card>
    </div>

    <!-- Right side: Payment Form -->
    <div class="payment-form-container">
      <app-payment-form></app-payment-form>
    </div>
  </div>
</div>